// extracted by mini-css-extract-plugin
export default {"container":"CustomActivityCalender_container__ttKMG","calendarBox":"CustomActivityCalender_calendarBox__j8mC1"};